import { ISideMenuCategoryLang, SIDE_MENU_CATEGORY_LANG_KEY } from './interface.ISideMenuCategoryLang'
import { ISideMenuLang, SIDE_MENU_LANG_KEY } from './interface.ISideMenuLang'

export * from './interface.ISideMenuLang'
export * from './interface.ISideMenuCategoryLang'

export type ISideMenuAllLang = ISideMenuCategoryLang & ISideMenuLang

export const SIDE_MENU_ALL_LANG_KEY: ISideMenuAllLang = {
	...SIDE_MENU_LANG_KEY,
	...SIDE_MENU_CATEGORY_LANG_KEY
}